module.exports = __webpack_public_path__ + "8ff0f76721381f7c16efd48122a66b42.pdf";